import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-3" }
const _hoisted_2 = { key: 0 }

import { computed, onMounted, ref, watch } from 'vue';
import api from '@/api';
import { toast } from '@/lib/toast';

const OTHER_REASON_CODE = 'other';

interface Reason {
  id: number;
  code: string;
  orderNumber: number;
  description: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CancellationReasonsDecision',
  props: {
  reasons: Array<{
    id: number,
    explanation?: string,
  }>,
  isValid: Boolean,
},
  emits: ['update:reasons', 'update:isValid'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const reasons = ref<Reason[]>([]);

const otherReasonId = computed(
    () => reasons.value.find((reason: Reason) => reason.code === OTHER_REASON_CODE)?.id
);

const updateReasons = (reasons: Array<number>, otherReason?: string) => {
  emit(
    'update:reasons',
    reasons.map(id => {
      return {
        id,
        explanation: id === otherReasonId.value && otherReason ? otherReason : null,
      };
    }),
  );
};

const selected = computed({
  get: () => props.reasons.map(reason => reason.id),
  set: (newValue) => updateReasons(newValue, otherReasonExplanation.value),
});
const otherReasonExplanation = computed({
  get: () => props.reasons.find(reason => reason.id === otherReasonId.value)?.explanation ?? '',
  set: (newValue) => updateReasons(selected.value, newValue),
});

watch(
  () => reasons.value.length > 0 && selected.value.length > 0
    && (!selected.value.includes(otherReasonId.value) || otherReasonExplanation.value.trim().length > 0),
  (value) => emit('update:isValid', value)
);

onMounted(async () => {
  try {
    reasons.value = await api.get(`/vocab/procedure-cancellation-reasons`);
  } catch (e) {
    toast.error(e.message);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Процедура будет признана несостоявшейся, т.к. Вы не выбрали победителя. Укажите, пожалуйста, причину отсутствия победителя.')), 1 /* TEXT */),
    (!reasons.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('Загрузка списка причин...')), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reasons.value, (reason) => {
      return (_openBlock(), _createBlock(_component_v_checkbox_btn, {
        key: reason.id,
        label: reason.description,
        value: reason.id,
        modelValue: selected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
        "true-icon": "custom:checkboxOutline",
        "false-icon": "custom:checkboxBlankOutline",
        color: "primary",
        class: "pb-3"
      }, null, 8 /* PROPS */, ["label", "value", "modelValue"]))
    }), 128 /* KEYED_FRAGMENT */)),
    (selected.value.find((id) => id === otherReasonId.value) !== undefined)
      ? (_openBlock(), _createBlock(_component_v_textarea, {
          key: 1,
          rows: 3,
          maxlength: "255",
          variant: "outlined",
          modelValue: otherReasonExplanation.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((otherReasonExplanation).value = $event)),
          "hide-details": "",
          placeholder: _ctx.$t('Укажите причину отсутствия победителя')
        }, null, 8 /* PROPS */, ["modelValue", "placeholder"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})